// extracted by mini-css-extract-plugin
module.exports = {"fileList":"Details_fileList__1SQmE","dialog":"Details_dialog__3GRK3"};